module.exports = __webpack_public_path__ + "static/img/box-bg2.a9bac0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/box-bg2.png
// module id = WsJp
// module chunks = 0